// API設定
export const API_BASE_URL = import.meta.env.PROD 
  ? 'https://zaiko-adjust-app.valleyintest.workers.dev'
  : '';

